import audio2 from 'assets/sounds/nn/2 3 Ordkjedetest-Feil-los-tupp-meg-sa.mp3';
import audio3 from 'assets/sounds/nn/2 4 Ordkjedetest-Feil-ost-par-vask-jakt.mp3';
import audio4 from 'assets/sounds/nn/2 6 Ordkjedetest-Feil-hus-grei.mp3';

import audio2norm from 'assets/sounds/nn/2 3 Ordkjedetest-Feil-los-tupp-meg-sa-norming.mp3';
import audio3norm from 'assets/sounds/nn/2 4 Ordkjedetest-Feil-ost-par-vask-jakt-norming.mp3';
import audio4norm from 'assets/sounds/nn/2 6 Ordkjedetest-Feil-hus-grei-norming.mp3';

const assignmentsNn = [
	{
		id: 1,
		text: 'påske last mil frå',
		answer: 'påske last mil frå',
	},
	{
		id: 2,
		text: 'laustuppmegsa',
		answer: 'laus tupp meg sa',
		audio: audio2,
		count: 'andre',
		hasPlayed: false,
	},
	{
		id: 3,
		text: 'ostparvaskjakt',
		answer: 'ost par vask jakt',
		audio: audio3,
		count: 'tredje',
		hasPlayed: false,
	},
	{
		id: 4,
		text: 'husgreisåsær',
		answer: 'hus grei så sær',
		audio: audio4,
		count: 'fjerde',
		hasPlayed: false,
	},
];

const assignmentsNnNorming = [
	{
		id: 1,
		text: 'påske last mil frå',
		answer: 'påske last mil frå',
	},
	{
		id: 2,
		text: 'laustuppmegsa',
		answer: 'laus tupp meg sa',
		audio: audio2norm,
		count: 'andre',
		hasPlayed: false,
	},
	{
		id: 3,
		text: 'ostparvaskjakt',
		answer: 'ost par vask jakt',
		audio: audio3norm,
		count: 'tredje',
		hasPlayed: false,
	},
	{
		id: 4,
		text: 'husgreisåsær',
		answer: 'hus grei så sær',
		audio: audio4norm,
		count: 'fjerde',
		hasPlayed: false,
	},
];
export {assignmentsNn, assignmentsNnNorming};
